import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import init from "../../firebase";
import { useUserAuth } from "../../context/UserAuthContext";
import { useFormik } from "formik";
import { basicDetailsSchema } from "../schemas";
import CustomSelect from "../customSelect/CustomSelect";
import {
  linkWithCredential,
  RecaptchaVerifier,
  PhoneAuthProvider,
  unlink,
} from "firebase/auth";
import { getFirebaseErrorMessage } from "../getFirebaseErrorMessage";
import axios from "axios";
import {
  FiEdit2,
  FiSave,
  FiX,
  FiPhone,
  FiLink,
  FiGlobe,
  FiMapPin,
  FiCalendar,
  FiUser,
  FiMail,
  FiHome,
  FiNavigation,
} from "react-icons/fi";
import "./basic.css";
import { Modal } from "react-bootstrap";
import Select from 'react-select';


const BasicDetails = () => {
  const auth = init.auth;
  const [showModal, setShowModal] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationId, setVerificationId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [edit, setEdit] = useState(false);
  const { user, language, token, defaultCountry } = useUserAuth();
  console.log("default country", defaultCountry);
  const merchant_id = user.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [merchant, setMerchant] = useState({});
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [locality, setLocality] = useState([])
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [currencies, setCurrencies] = useState([]);
  const [mobNumber, setMobNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [canResend, setCanResend] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [isVerificationSent, setIsVerificationSent] = useState(false);
  const [currentLinkedPhone, setCurrentLinkedPhone] = useState(null);
  const current_mobno = auth.currentUser?.phoneNumber

  const [pendingChanges, setPendingChanges] = useState(null);
  console.log("Pending changes:", pendingChanges);

  const fetchRequests = async () => {
    if (!user?.uid) return;
    try {
      const res = await axios.get(
        `${base_url}/api/v1/change-basic/basic-detail/${user?.uid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setPendingChanges(res.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, [token]);

  const PendingChangesIndicator = ({ field, currentValue, pendingValue, label }) => {
    if (!pendingValue || pendingValue === currentValue) return null;
    const formatValue = (value) => {
      if (!value) return "Not set";
      if (typeof value === 'object') return value.label || value.value || "N/A";
      return value;
    };
    return (
      <div className="pending-change-alert">
        <small className="text-warning">
          <strong>{label}:</strong> Your change from "{formatValue(currentValue)}" to "{formatValue(pendingValue)}" is pending approval.
        </small>
      </div>
    );
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsVerificationSent(false);
    setVerificationId("");
    setVerificationCode("");
    setResendTimer(0);
    setCanResend(false);
    setMobNumber('');
  }

  const handleShowModal = (mobno, curr_code, flag) => {
    setMobNumber(mobno || '');
    setSelectedCountry({
      value: curr_code,
      label: `${flag} ${curr_code}`,
      flag: flag,
    });
    if (mobno) {
      setCurrentLinkedPhone(`${curr_code}${mobno}`);
    }
    setIsVerificationSent(false);
    setVerificationId("");
    setVerificationCode("");
    setShowModal(true);
  };
  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0 && isVerificationSent) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [resendTimer, isVerificationSent]);

  const startResendTimer = () => {
    setCanResend(false);
    setResendTimer(30); // 30 seconds timer
  };

  const setUpRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => { },
          "expired-callback": () => { },
        },
        auth
      );
    }
  };

  const sendVerificationCode = async () => {
    if (!mobNumber || !selectedCountry) {
      toast.error("Please enter a valid phone number");
      return;
    }

    const newPhoneNumber = `${selectedCountry.value}${mobNumber}`;
    formik.setFieldValue("mobno_code", selectedCountry.code);
    // Check if user is trying to verify the same number that's already linked
    if (currentLinkedPhone && newPhoneNumber === currentLinkedPhone) {
      toast.info("This phone number is already linked to your account");
      return;
    }

    try {
      setIsLoading(true);
      setUpRecaptcha();
      const appVerifier = window.recaptchaVerifier;
      const phoneProvider = new PhoneAuthProvider(auth);

      const verificationId = await phoneProvider.verifyPhoneNumber(newPhoneNumber, appVerifier);
      setVerificationId(verificationId);
      setIsVerificationSent(true);
      startResendTimer();
      toast.success("Verification code sent successfully");
    } catch (error) {
      console.error("Error during verification code sending:", error);
      toast.error(getFirebaseErrorMessage(error.code));
    } finally {
      setIsLoading(false);
    }
  };

  const resendVerificationCode = async () => {
    if (!canResend) return;

    try {
      setIsLoading(true);
      const appVerifier = window.recaptchaVerifier;
      const phoneProvider = new PhoneAuthProvider(auth);
      const newPhoneNumber = `${selectedCountry.value}${mobNumber}`;
      const verificationId = await phoneProvider.verifyPhoneNumber(newPhoneNumber, appVerifier);
      setVerificationId(verificationId);
      startResendTimer();
      toast.success("Verification code resent successfully");
    } catch (error) {
      console.error("Error during verification code resending:", error);
      toast.error(getFirebaseErrorMessage(error.code));
    } finally {
      setIsLoading(false);
    }
  };

  const updatePhoneNumber = async () => {
    if (!verificationCode) {
      toast.error("Please enter verification code");
      return;
    }

    try {
      setIsLoading(true);
      const credential = PhoneAuthProvider.credential(
        verificationId,
        verificationCode
      );

      const user = auth.currentUser;
      const providers = user.providerData;
      const phoneProvider = providers.find(provider => provider.providerId === 'phone');

      if (phoneProvider) {
        await unlink(user, 'phone');
        console.log("Previous phone number unlinked");
      }
      await linkWithCredential(user, credential);
      const newPhoneNumber = `${selectedCountry.value}${mobNumber}`;
      toast.success("Phone number updated successfully");
      handleCloseModal();
    } catch (error) {
      const res = getFirebaseErrorMessage(error.code);
      if (error.code === 'auth/provider-already-linked') {
        toast.error("This phone number is already linked to another account");
      } else if (error.code === 'auth/requires-recent-login') {
        toast.error("Please sign in again to update your phone number");
      } else {
        toast.error(res);
      }
      console.log("Phone update error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleChangeMobileNumber = () => {
    setIsVerificationSent(false);
    setVerificationId("");
    setVerificationCode("");
    setCanResend(false);
    setResendTimer(0);
  };

  const getSingleDocumentHandler = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${base_url}/api/v1/users/id/${merchant_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const sub_cat_id = res?.data?.data?.sub_category_id;
      const merchantData = res?.data?.data;
      formik.setValues({
        ...merchantData,
        mobno_code: merchantData.mobno_code || defaultCountry?.code,
        alternate_country_code: merchantData.alternate_country_code || defaultCountry?.code,
        whatsapp_country_code: merchantData.whatsapp_country_code || defaultCountry?.code,
      });
      setMerchant(merchantData);
      const result = await axios.get(
        `${base_url}/api/v1/user-about-mgmt/sub-cat-wise/${sub_cat_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTemplates(result?.data.data);
    } catch (error) {
      console.log(`Error ${error} `);
      toast.error("Failed to load profile data");
    } finally {
      setLoading(false);
    }
  };

  // Helper functions
  const getNotificationMessage = (notificationKey, templates, data) => {
    const templateObj = templates.find(
      (template) => template.id === notificationKey
    );
    if (!templateObj) return false;

    let notificationText = templateObj.about_us;
    for (const key in data) {
      notificationText = notificationText.replace(
        new RegExp(`{{${key}}}`, "g"),
        data[key]
      );
    }
    return { message: notificationText };
  };

  useEffect(() => {
    if (!defaultCountry) return
    setSelectedCountry({
      value: formik.values?.mobno,
      label: `${defaultCountry?.flag} ${defaultCountry?.code}`,
      flag: defaultCountry?.flag,
    });
  }, [defaultCountry])

  useEffect(() => {
    const getCountry = async () => {
      try {
        const res = await axios.get(`${base_url}/api/v1/countries`);
        setCountry(res.data.data);
      } catch (error) {
        console.log(`Error ${error} `);
      }
    };
    const getState = async () => {
      try {
        const res = await axios.get(`${base_url}/api/v1/states`);
        setState(
          res.data.data.map((doc) => ({
            key: doc.id,
            value: doc.name,
            country_id: doc.country_id,
          }))
        );
      } catch (err) {
        console.log(`Error is ${err}`);
      }
    };
    const getCity = async () => {
      try {
        const res = await axios.get(`${base_url}/api/v1/cities`);
        setCity(
          res.data.data.map((doc) => ({
            key: doc.id,
            value: doc.name,
            state_id: doc.state_id,
          }))
        );
      } catch (err) {
        console.log(`Error is ${err}`);
      }
    };
    const getLocality = async () => {
      try {
        const res = await axios.get(`${base_url}/api/v1/localities`);
        setLocality(
          res.data.data.map((doc) => ({
            key: doc.id,
            value: doc.name,
            city_id: doc.city_id,
          }))
        );
      } catch (err) {
        console.log(`Error is ${err}`);
      }
    };
    getCountry();
    getState();
    getCity();
    getLocality();
  }, []);

  useEffect(() => {
    if (!merchant_id) return;
    getSingleDocumentHandler();
  }, [merchant_id]);

  const formik = useFormik({
    initialValues: {
      country_id: "",
      state_id: "",
      city_id: "",
      pincode: "",
      locality_id: "",
      street: "",
      landmark: "",
      mobno: "",
      email: "",
      gst: "",
      workingsince: "",
      name: "",
      fb: "",
      insta: "",
      introduction: "",
      maplink: "",
      weblink: "",
      youtube_link: "",
      mobno_code: "",
      alternate_number: "",
      alternate_country_code: "",
      whatsapp_number: "",
      whatsapp_country_code: "",
    },
    validationSchema: basicDetailsSchema,

    onSubmit: async (values) => {
      try {
        setLoading(true);
        const trimmedIntro = values.introduction?.slice(0, 250) || "";
        const formData = {
          ...values,
          mobno: current_mobno?.slice(3) || values.mobno,
          mobno_code: values.mobno_code || defaultCountry?.code,
          alternate_country_code: values.alternate_country_code || defaultCountry?.code,
          whatsapp_country_code: values.whatsapp_country_code || defaultCountry?.code,
        };
        const res = await axios.post(
          `${base_url}/api/v1/users/basic-details/${merchant_id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (trimmedIntro) {
          const response = await axios.post(
            `${base_url}/api/v1/users/update-meta-details/${merchant_id}`,
            {
              meta_description: trimmedIntro,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }
        if (res.status === 201) {
          toast.success("Profile Updated Successfully.");
        } else if (res.status === 202) {
          toast.success("Your update is pending approval by the admin.");
        }
        // else if (res.status === 409) {
        //   toast.warning(
        //     "You already have a pending request. Please wait until it is approved or rejected."
        //   );
        // } 
        else {
          toast.info(res.data.message || "Request submitted.");
        }
        getSingleDocumentHandler();
        fetchRequests();
        setEdit(false);
      } catch (error) {
        if (error.response) {
          const { status, data } = error.response;

          if (status === 409) {
            toast.warning(
              data.message ||
              "You already have a pending request. Please wait for approval or rejection."
            );
            setEdit(false);
          } else {
            toast.error(data.message || "Something went wrong.");
          }
        } else {
          toast.error("Network error. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    },
  });
  useEffect(() => {
    if (defaultCountry && !formik.values.mobno_code) {
      formik.setFieldValue("mobno_code", defaultCountry.code);
    }
    if (defaultCountry && !formik.values.alternate_country_code) {
      formik.setFieldValue("alternate_country_code", defaultCountry.code);
    }
    if (defaultCountry && !formik.values.whatsapp_country_code) {
      formik.setFieldValue("whatsapp_country_code", defaultCountry.code);
    }
  }, [defaultCountry]);

  const InfoCard = ({ icon, title, value, className = "", code = "", pendingValue = null, fieldName = "" }) => {
    const formattedCode = code && !code.startsWith("+") ? `+${code}` : code;
    const displayValue = formattedCode && value ? `${formattedCode}${value}` : value;
    const pendingDisplayValue = pendingValue && code ? `${formattedCode}${pendingValue}` : pendingValue;
    const hasPending =
      pendingValue !== undefined &&
      pendingValue !== null &&
      pendingValue !== value;

    const finalValue = hasPending
      ? pendingDisplayValue || pendingValue
      : displayValue || value;
    return (
      <div className={`info-card ${className}`}>
        <div className="info-card-header">
          <span className="info-card-icon">{icon}</span>
          <h3 className="info-card-title">{title}</h3>
          {pendingValue && pendingValue !== value && (
            <span className="pending-badge">Pending</span>
          )}
        </div>
        <p className={`info-card-value ${!finalValue ? "empty" : ""}`}>
          {finalValue || "Not provided"}
        </p>

        {hasPending && (
          <PendingChangesIndicator
            field={fieldName}
            currentValue={value}
            pendingValue={pendingDisplayValue || pendingValue}
            label={title}
          />
        )}
      </div>
    );
  };
  const getPendingValue = (pendingChanges, field) => {
    if (!pendingChanges?.changes) return null;
    return pendingChanges.changes[field];
  };
  useEffect(() => {
    if (pendingChanges?.changes) {
      console.log("Pending changes detected:", pendingChanges.changes);
    }
  }, [pendingChanges]);
  const SocialLink = ({ icon, link }) =>
    link && (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="social-link"
      >
        {icon}
      </a>
    );
  const fetchCurrentCountry = useCallback(async () => {
    if (!location?.country) return;
    try {
      const countryName = location.country.trim();
      const res = await axios.get(
        `${base_url}/api/v1/currency/country_name/?country=${countryName}`
      );
      if (res?.data?.data) {
        const countryData = res?.data?.data;
        console.log('this data get to ip address', countryData);
        setSelectedCountry({
          value: countryData.country_id,
          label: `${countryData.flag} ${countryData.code}`,
          code: countryData.code?.replace('+', ''),
          flag: countryData.flag,
          name: countryData.country_name
        });
      }
    } catch (error) {
      console.error('Error fetching user country:', error);
    }
  }, [location?.country]);
  const fetchCurrency = useCallback(async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/currency/country`
      );
      const data = Array.isArray(res?.data?.data) ? res?.data?.data : [];
      setCurrencies(data);
      if (!selectedCountry) {
        const india = data.find(c => c.country_name === "India");
        if (india) {
          setSelectedCountry({
            value: india.country_id,
            label: `${india.flag} ${india.code}`,
            code: india.code.replace('+', ''),
            flag: india.flag,
            name: india.country_name,
            id: india.id
          });
        }
      }
    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
  }, [selectedCountry]);

  useEffect(() => {
    fetchCurrency();
    if (location?.country) {
      fetchCurrentCountry();
    }
  }, [fetchCurrency, fetchCurrentCountry, location?.country]);

  const countryOptions = currencies.map(item => ({
    value: item.country_id,
    label: `${item.flag} ${item.code}`,
    code: item.code.replace('+', ''),
    flag: item.flag,
    name: item.country_name,
    id: item.id
  }));
  const getPendingDisplayValue = (field, dataArray, keyField = 'key', valueField = 'value') => {
    const pendingId = getPendingValue(pendingChanges, field);
    if (!pendingId) return null;
    const item = dataArray?.find(item => item[keyField] === pendingId);
    return item ? item[valueField] : null;
  };

  return (
    <div className="page-wrapper">
      <div className="profile-container">
        <div className="profile-card">
          {/* Header */}
          <div className="card-header">
            <h2>
              {language === "en" ? "Business Profile" : "व्यवसाय प्रोफाइल"}
            </h2>
            {!edit ? (
              <button onClick={() => setEdit(true)} className="btn btn-light">
                <FiEdit2 className="btn-icon" />
                {language === "en" ? "Edit Profile" : "प्रोफाइल संपादित करें"}
              </button>
            ) : (
              <button
                onClick={() => setEdit(false)}
                className="btn btn-outline"
              >
                <FiX className="btn-icon" />
                Cancel
              </button>
            )}
          </div>

          {loading && (
            <div className="loading-container">
              <div className="spinner"></div>
              <p className="loading-text">Loading profile data...</p>
            </div>
          )}

          {!loading && !edit && (
            <div className="card-body">
              {/* <BasicDetailApprovalStatus /> */}
              {/* Contact Information */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiMail className="section-header-icon" />
                  {language === "en" ? "Contact Information" : "संपर्क जानकारी"}
                </h3>
                <div className="info-grid">
                  <InfoCard
                    icon={<FiMail />}
                    title="Email"
                    value={merchant?.email}
                    pendingValue={getPendingValue(pendingChanges, 'email')}
                    fieldName="email"
                  />
                  <InfoCard
                    icon={<FiPhone />}
                    title="Mobile Number"
                    value={merchant?.mobno}
                    code={merchant?.mobno_code || defaultCountry?.code}
                    pendingValue={getPendingValue(pendingChanges, 'mobno')}
                    fieldName="mobno"
                  />
                  <InfoCard
                    icon={<FiUser />}
                    title="Contact Person"
                    value={merchant?.name}
                    pendingValue={getPendingValue(pendingChanges, 'name')}
                    fieldName="name"
                  />
                  <InfoCard
                    icon={<FiCalendar />}
                    title="Working Since"
                    value={merchant?.workingsince}
                    pendingValue={getPendingValue(pendingChanges, 'workingsince')}
                    fieldName="workingsince"
                  />
                  <InfoCard
                    icon={<FiPhone />}
                    title="Alternate Number"
                    value={merchant?.alternate_number}
                    code={merchant?.alternate_country_code || defaultCountry?.code}
                    pendingValue={getPendingValue(pendingChanges, 'alternate_number')}
                    fieldName="alternate_number"
                  />
                  <InfoCard
                    icon={<FiPhone />}
                    title="WhatsApp Number"
                    value={`${merchant?.whatsapp_number ? merchant?.whatsapp_number : ''}`}
                    code={merchant?.whatsapp_country_code || defaultCountry?.code}
                    pendingValue={getPendingValue(pendingChanges, 'whatsapp_number')}
                    fieldName="whatsapp_number"
                  />
                </div>
              </div>

              {/* Business Address */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiMapPin className="section-header-icon" />
                  {language === "en" ? "Business Address" : "व्यवसाय का पता"}
                </h3>
                <div className="info-grid">
                  <InfoCard
                    icon={<FiGlobe />}
                    title="Country"
                    value={
                      country?.find((c) => c.id === merchant?.country_id)?.name
                    }
                    pendingValue={
                      getPendingDisplayValue('country_id', country, 'id', 'name')
                    }
                    fieldName="country_id"
                  />
                  <InfoCard
                    icon={<FiNavigation />}
                    title="State"
                    value={
                      state?.find((s) => s.key === merchant?.state_id)?.value
                    }
                    pendingValue={
                      getPendingDisplayValue('state_id', state, 'key', 'value')
                    }
                    fieldName="state_id"
                  />
                  <InfoCard
                    icon={<FiHome />}
                    title="City"
                    value={
                      city?.find((c) => c.key === merchant?.city_id)?.value
                    }
                    pendingValue={
                      getPendingDisplayValue('city_id', city, 'key', 'value')
                    }
                    fieldName="city_id"
                  />
                  <InfoCard
                    icon={<FiMapPin />}
                    title={
                      merchant?.country_id === "4Dj1nUEkp4vFOh4HI0CL"
                        ? "Locality"
                        : "Locality (Optional)"
                    }
                    value={
                      locality?.find((l) => l.key === merchant?.locality_id)
                        ?.value
                    }
                    pendingValue={
                      getPendingDisplayValue('locality_id', locality, 'key', 'value')
                    }
                    fieldName="locality_id"
                  />
                  <InfoCard
                    icon={<FiMapPin />}
                    title="Street/Area"
                    value={merchant?.street}
                    pendingValue={getPendingValue(pendingChanges, 'street')}
                    fieldName="street"
                  />
                  <InfoCard
                    icon={<FiMapPin />}
                    title="Landmark"
                    value={merchant?.landmark}
                    pendingValue={getPendingValue(pendingChanges, 'landmark')}
                    fieldName="landmark"
                  />
                  <InfoCard
                    icon={<FiMapPin />}
                    title="Pincode"
                    value={merchant?.pincode}
                    pendingValue={getPendingValue(pendingChanges, 'pincode')}
                    fieldName="pincode"
                  />
                </div>
              </div>

              {/* Business Details */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiGlobe className="section-header-icon" />
                  {language === "en" ? "Business Details" : "व्यवसाय विवरण"}
                </h3>
                <div className="info-grid">
                  <InfoCard
                    icon={<FiLink />}
                    title="GST Number"
                    value={merchant?.gst}
                    pendingValue={getPendingValue(pendingChanges, 'gst')}
                    fieldName="gst"
                  />
                  <InfoCard
                    icon={<FiLink />}
                    title="Website"
                    value={merchant?.weblink}
                    pendingValue={getPendingValue(pendingChanges, 'weblink')}
                    fieldName="weblink"
                  />
                  <InfoCard
                    icon={<FiLink />}
                    title="Google Map Link"
                    value={merchant?.maplink}
                    pendingValue={getPendingValue(pendingChanges, 'maplink')}
                    fieldName="maplink"
                  />
                </div>
              </div>

              {/* Social Links - Updated with pending changes */}
              {(merchant?.fb || merchant?.insta || merchant?.youtube_link) && (
                <div className="form-section">
                  <h3 className="section-header">
                    <FiLink className="section-header-icon" />
                    {language === "en" ? "Social Links" : "सोशल लिंक"}
                  </h3>
                  <div className="info-grid">
                    {merchant?.fb && (
                      <InfoCard
                        icon={<span>FB</span>}
                        title="Facebook"
                        value={merchant?.fb}
                        pendingValue={getPendingValue(pendingChanges, 'fb')}
                        fieldName="fb"
                      />
                    )}
                    {merchant?.insta && (
                      <InfoCard
                        icon={<span>IG</span>}
                        title="Instagram"
                        value={merchant?.insta}
                        pendingValue={getPendingValue(pendingChanges, 'insta')}
                        fieldName="insta"
                      />
                    )}
                    {merchant?.youtube_link && (
                      <InfoCard
                        icon={<span>YT</span>}
                        title="YouTube"
                        value={merchant?.youtube_link}
                        pendingValue={getPendingValue(pendingChanges, 'youtube_link')}
                        fieldName="youtube_link"
                      />
                    )}
                  </div>
                </div>
              )}

              {/* Business Introduction - Add pending indicator */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiUser className="section-header-icon" />
                  {language === "en"
                    ? "Business Introduction"
                    : "व्यवसाय परिचय"}
                </h3>
                <div className="info-card">
                  <p>
                    {merchant?.introduction || (
                      <span className="info-card-value empty">
                        No introduction provided
                      </span>
                    )}
                  </p>
                  {getPendingValue(pendingChanges, 'introduction') && (
                    <PendingChangesIndicator
                      field="introduction"
                      currentValue={merchant?.introduction || "Not provided"}
                      pendingValue={getPendingValue(pendingChanges, 'introduction')}
                      label="Business Introduction"
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          {!loading && edit && (
            <form onSubmit={formik.handleSubmit} className="card-body">
              {/* Contact Information Section */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiUser className="section-header-icon" />
                  {language === "en" ? "Contact Information" : "संपर्क जानकारी"}
                </h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Contact Person Name</label>
                    <input
                      type="text"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className={`form-control ${formik.touched.name && formik.errors.name
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div className="invalid-feedback">
                        {formik.errors.name}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      onChange={formik.handleChange}
                      placeholder="Enter your email"
                      className="form-control"
                      value={formik.values.email}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      Mobile Number
                      <button
                        type="button"
                        onClick={() => handleShowModal(formik.values.mobno, formik.values.mobno_code || defaultCountry?.code, defaultCountry?.flag)}
                        className="btn btn-link"
                      >
                        (Link Account)
                      </button>
                    </label>
                    <div style={{ display: "flex", alignItems: "center", width: "100%", height: "5px" }}>
                      <div style={{ flex: "0 0 100px" }}>
                        <Select
                          options={countryOptions}
                          value={countryOptions.find(opt => opt.code === formik.values.mobno_code) || {
                            value: formik.values.mobno_code,
                            label: `${defaultCountry?.flag} ${defaultCountry?.code}`,
                            code: formik.values.mobno_code,
                            flag: defaultCountry?.flag
                          }}
                          onChange={(selected) => {
                            formik.setFieldValue("mobno_code", selected.code);
                          }}
                          menuPosition="fixed"
                          isSearchable
                          placeholder="Search..."
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              border: "1px solid #ccc",
                              minHeight: "35px",
                              borderRadius: "4px",
                              borderTopRightRadius: "0px",
                              borderBottomRightRadius: "0px",
                              boxShadow: "none",
                            }),
                            // ... rest of styles
                          }}
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => null,
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <input
                          type="tel"
                          name="mobno"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={current_mobno?.slice(3) || formik.values.mobno}
                          className={`form-control ${formik.touched.mobno && formik.errors.mobno ? "is-invalid" : ""}`}
                          style={{
                            height: "35px",
                            borderRadius: "4px",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                          }}
                        />
                        {formik.touched.mobno && formik.errors.mobno && (
                          <div className="invalid-feedback">{formik.errors.mobno}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Alternate Number Field */}
                  <div className="form-group">
                    <label className="form-label">Alternate Number</label>
                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                      <div style={{ flex: "0 0 100px" }}>
                        <Select
                          options={countryOptions}
                          value={countryOptions.find(opt => opt.code === formik.values.alternate_country_code) || {
                            value: defaultCountry?.code,
                            label: `${defaultCountry?.flag} ${defaultCountry?.code}`,
                            code: defaultCountry?.code,
                            flag: defaultCountry?.flag
                          }}
                          onChange={(selected) => {
                            formik.setFieldValue("alternate_country_code", selected.code);
                          }}
                          menuPosition="fixed"
                          isSearchable
                          placeholder="Search..."
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              border: "1px solid #ccc",
                              minHeight: "35px",
                              borderRadius: "4px",
                              borderTopRightRadius: "0px",
                              borderBottomRightRadius: "0px",
                              boxShadow: "none",
                            }),
                            // ... rest of styles
                          }}
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => null,
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <input
                          type="tel"
                          name="alternate_number"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.alternate_number}
                          className="form-control"
                          maxLength={10}
                          style={{
                            height: "35px",
                            borderRadius: "4px",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* WhatsApp Number Field */}
                  <div className="form-group">
                    <label className="form-label">WhatsApp Number</label>
                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                      <div style={{ flex: "0 0 100px" }}>
                        <Select
                          options={countryOptions}
                          value={countryOptions.find(opt => opt.code === formik.values.whatsapp_country_code) || {
                            value: defaultCountry?.code,
                            label: `${defaultCountry?.flag} ${defaultCountry?.code}`,
                            code: defaultCountry?.code,
                            flag: defaultCountry?.flag
                          }}
                          onChange={(selected) => {
                            formik.setFieldValue("whatsapp_country_code", selected.code);
                          }}
                          menuPosition="fixed"
                          isSearchable
                          placeholder="Search..."
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              border: "1px solid #ccc",
                              minHeight: "35px",
                              borderRadius: "4px",
                              borderTopRightRadius: "0px",
                              borderBottomRightRadius: "0px",
                              boxShadow: "none",
                            }),
                            // ... rest of styles
                          }}
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => null,
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <input
                          type="tel"
                          name="whatsapp_number"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.whatsapp_number}
                          className="form-control"
                          maxLength={10}
                          style={{
                            height: "35px",
                            borderRadius: "4px",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Working Since (Year)</label>
                    <input
                      type="number"
                      name="workingsince"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.workingsince}
                      className={`form-control ${formik.touched.workingsince &&
                        formik.errors.workingsince
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {formik.touched.workingsince &&
                      formik.errors.workingsince && (
                        <div className="invalid-feedback">
                          {formik.errors.workingsince}
                        </div>
                      )}
                  </div>
                </div>
              </div>

              {/* Business Address Section */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiMapPin className="section-header-icon" />
                  {language === "en" ? "Business Address" : "व्यवसाय का पता"}
                </h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Country</label>
                    <select
                      name="country_id"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.country_id}
                      className={`form-control ${formik.touched.country_id && formik.errors.country_id
                        ? "is-invalid"
                        : ""
                        }`}
                    >
                      <option value="">Select Country</option>
                      {country?.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {formik.touched.country_id && formik.errors.country_id && (
                      <div className="invalid-feedback">
                        {formik.errors.country_id}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <CustomSelect
                      title="State"
                      placeholder="Select State"
                      name="state_id"
                      data={state?.filter(
                        (pre) => pre?.country_id === formik.values?.country_id
                      )}
                      defaultValue={formik.values.state_id}
                      onChange={(value) =>
                        formik.setFieldValue("state_id", value)
                      }
                      error={formik.touched.state_id && formik.errors.state_id}
                    />
                  </div>

                  <div className="form-group">
                    <CustomSelect
                      title="City"
                      placeholder="Select City"
                      name="city_id"
                      data={city?.filter(
                        (pre) => pre?.state_id === formik.values?.state_id
                      )}
                      defaultValue={formik.values.city_id}
                      onChange={(value) =>
                        formik.setFieldValue("city_id", value)
                      }
                      error={formik.touched.city_id && formik.errors.city_id}
                    />
                  </div>

                  <div className="form-group">
                    <CustomSelect
                      title={
                        formik.values.country_id === "4Dj1nUEkp4vFOh4HI0CL"
                          ? "Locality"
                          : "Locality"
                      }
                      isRequired={
                        formik.values.country_id === "4Dj1nUEkp4vFOh4HI0CL"
                      }
                      placeholder="Enter Locality"
                      name="locality_id"
                      data={locality}
                      defaultValue={formik.values.locality_id}
                      onChange={(value) =>
                        formik.handleChange("locality_id")(value)
                      }
                      error={
                        formik.touched.locality_id && formik.errors.locality_id
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Street/Area</label>
                    <input
                      type="text"
                      name="street"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.street}
                      className={`form-control ${formik.touched.street && formik.errors.street
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {formik.touched.street && formik.errors.street && (
                      <div className="invalid-feedback">
                        {formik.errors.street}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Landmark</label>
                    <input
                      type="text"
                      name="landmark"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.landmark}
                      className="form-control"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Pincode</label>
                    <input
                      type="text"
                      name="pincode"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pincode}
                      className={`form-control ${formik.touched.pincode && formik.errors.pincode
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {formik.touched.pincode && formik.errors.pincode && (
                      <div className="invalid-feedback">
                        {formik.errors.pincode}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Business Details Section */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiGlobe className="section-header-icon" />
                  {language === "en" ? "Business Details" : "व्यवसाय विवरण"}
                </h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">GST Number</label>
                    <input
                      type="text"
                      name="gst"
                      maxLength={15}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gst}
                      className={`form-control ${formik.touched.gst && formik.errors.gst
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {formik.touched.gst && formik.errors.gst && (
                      <div className="invalid-feedback">
                        {formik.errors.gst}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Website Link</label>
                    <input
                      type="url"
                      name="weblink"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.weblink}
                      className="form-control"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Google Map Link</label>
                    <input
                      type="url"
                      name="maplink"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.maplink}
                      className="form-control"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">YouTube Link</label>
                    <input
                      type="url"
                      name="youtube_link"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.youtube_link}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              {/* Social Media Section */}
              <div className="form-section">
                <h3 className="section-header">
                  <FiLink className="section-header-icon" />
                  {language === "en"
                    ? "Social Media Links"
                    : "सोशल मीडिया लिंक"}
                </h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label">Facebook Link</label>
                    <input
                      type="url"
                      name="fb"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fb}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Instagram Link</label>
                    <input
                      type="url"
                      name="insta"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.insta}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              {/* Business Introduction */}
              <div className="form-section">
                <div className="d-flex">
                  <h3 className="section-header">
                    <FiUser className="section-header-icon" />
                    {language === "en"
                      ? "Business Introduction"
                      : "व्यवसाय परिचय"}
                  </h3>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm ms-2 align-item-center justify-content-center"
                    onClick={() => setShowAbout(true)}
                  >
                    AI Generated
                  </button>
                </div>
                <div className="form-group">
                  <label className="form-label">About Your Business</label>
                  <textarea
                    name="introduction"
                    rows={5}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.introduction}
                    className={`form-control ${formik.touched.introduction && formik.errors.introduction
                        ? "is-invalid"
                        : ""
                      }`}
                  />
                  {formik.touched.introduction && formik.errors.introduction && (
                    <div className="invalid-feedback">{formik.errors.introduction}</div>
                  )}

                  {/* Character counter (optional) */}
                  <div className="form-text text-muted mt-1">
                    {formik.values.introduction?.length || 0} characters entered
                    {formik.values.introduction?.length < 160 && (
                      <span className="text-warning ms-2">
                        (need {160 - (formik.values.introduction?.length || 0)} more characters)
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button
                  type="button"
                  onClick={() => setEdit(false)}
                  className="btn btn-outline"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner"></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <FiSave className="btn-icon" />
                      Save Changes
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
        {/* Phone Verification Modal */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">
                  <FiPhone className="section-header-icon" />
                  {currentLinkedPhone ? "Update Phone Number" : "Link Phone Number"}
                </h3>
                <button onClick={handleCloseModal} className="btn btn-icon">
                  <FiX />
                </button>
              </div>
              <div className="modal-body">
                {/* Current Linked Phone Info */}
                {currentLinkedPhone && (
                  <div className="alert alert-info mb-3">
                    <small>
                      <strong>Current linked number:</strong> {currentLinkedPhone}
                      <br />
                      <span className="text-muted">Enter your new phone number below</span>
                    </small>
                  </div>
                )}

                <div className="form-group">
                  <label className="form-label">
                    {currentLinkedPhone ? "New Phone Number" : "Phone Number"}
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {/* Country Code Dropdown */}
                    <div style={{ flex: "0 0 110px" }}>
                      <Select
                        options={countryOptions}
                        value={selectedCountry}
                        onChange={(country) => {
                          setSelectedCountry(country);
                        }}
                        menuPosition="fixed"
                        isSearchable
                        placeholder="Code"
                        isDisabled={isVerificationSent}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            border: "1px solid #ccc",
                            minHeight: "38px",
                            borderRadius: "4px 0 0 4px",
                            boxShadow: "none",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        components={{
                          IndicatorSeparator: () => null,
                          DropdownIndicator: () => null,
                        }}
                      />
                    </div>

                    {/* Mobile Number Input */}
                    <div style={{ flex: 1 }}>
                      <input
                        type="text"
                        value={mobNumber}
                        onChange={(e) => setMobNumber(e.target.value)}
                        className="form-control"
                        style={{
                          borderRadius: "0 4px 4px 0",
                          borderLeft: "none",
                          height: "38px",
                        }}
                        placeholder={currentLinkedPhone ? "Enter new phone number" : "Enter phone number"}
                        disabled={isVerificationSent}
                      />
                    </div>
                  </div>

                  {/* Change Mobile Number Option */}
                  {isVerificationSent && (
                    <div className="mt-2">
                      <button
                        type="button"
                        onClick={handleChangeMobileNumber}
                        className="btn btn-link btn-sm"
                        style={{ padding: 0, fontSize: '0.875rem' }}
                      >
                        Change mobile number
                      </button>
                    </div>
                  )}
                </div>

                {verificationId && (
                  <div className="form-group mt-3">
                    <label className="form-label">Verification Code</label>
                    <input
                      type="text"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                      placeholder="Enter 6-digit code"
                      className="form-control"
                      maxLength={6}
                    />

                    {/* Resend OTP Section */}
                    <div className="mt-2 d-flex justify-content-between align-items-center">
                      <span className="text-muted small">
                        Didn't receive code?
                      </span>
                      {canResend ? (
                        <button
                          type="button"
                          onClick={resendVerificationCode}
                          disabled={isLoading}
                          className="btn btn-link btn-sm"
                          style={{ padding: 0, fontSize: '0.875rem' }}
                        >
                          Resend OTP
                        </button>
                      ) : (
                        <span className="text-muted small">
                          Resend in {resendTimer}s
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  onClick={handleCloseModal}
                  className="btn btn-outline"
                  disabled={isLoading}
                >
                  Close
                </button>
                {verificationId ? (
                  <button
                    onClick={updatePhoneNumber}
                    disabled={!verificationCode || isLoading}
                    className="btn btn-primary"
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {currentLinkedPhone ? 'Updating...' : 'Linking...'}
                      </>
                    ) : (
                      currentLinkedPhone ? 'Update Number' : 'Link Number'
                    )}
                  </button>
                ) : (
                  <button
                    onClick={sendVerificationCode}
                    disabled={!mobNumber || !selectedCountry || isLoading}
                    className="btn btn-primary"
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Send Verification Code'
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        <div id="recaptcha-container"></div>
        <Modal show={showAbout} onHide={() => setShowAbout(false)} scrollable>
          <Modal.Header closeButton>
            <Modal.Title>AI Generated Descriptions</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {templates?.map((item) => (
              <div
                key={item.key}
                className="p-2 mb-2 border rounded cursor-pointer hover-bg-light"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const result = getNotificationMessage(item.id, templates, {
                    business_name: merchant.business_name,
                    cat_name: merchant.category_name,
                    sub_cat_name: merchant.sub_category_name,
                    city: merchant.city_name,
                  });
                  if (result) {
                    formik.setFieldValue("introduction", result.message);
                  }
                  setShowAbout(false);
                }}
              >
                {item?.about_us}
              </div>
            ))}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
export default BasicDetails;